import request from '@/utils/request'

export function pagelistType(params) {
    return request({
      url: '/system/dicttype/pagelist',
      method: 'post',
      data:params
    })
}

export function addType(params){
    return request({
        url: '/system/dicttype/add',
        method: 'post',
        data:params
    })
}
export function getType(dictId){
    return request({
        url: '/system/dicttype/detail/'+dictId,
        method: 'get',
       
    })
}
export function updateType(params){
    return request({
        url: '/system/dicttype/edit',
        method: 'post',
        data:params
    })
}

export function delType(dictIds){
    return request({
        url: '/system/dicttype/remove/'+dictIds,
        method: 'get',
    })
}
export function optionselect(){
  
    return request({
        url: '/system/dicttype/optionselect',
        method: 'get',
    })
}



